export const AUTOFOCUS_FIRST_INVALID_CONSTANTS = {
    ELEMENT_TYPE: {
        RADIO_BUTTON: 'wdpr-radio',
        INPUT: 'wdpr-input'
    }
};
